import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowForwardIos } from "@mui/icons-material";
import "./Support.css";

const supportItems = [
  {
    text: "Troubleshooting Videos",
    iconUrl:
      "https://appcdn.goqii.com/storeimg/73028_1632380664.png",
    route: "https://www.youtube.com/playlist?list=PLfkRPBbsoOnMSQcJCdvQpl5feWht4_PEt",
  },
  {
    text: "Self Help",
    iconUrl:
      "https://appcdn.goqii.com/storeimg/17520_1617880034.png",
    route: "https://goqiisupport.zendesk.com/hc/en-us",
  },
  {
    text: "Click to Call",
    iconUrl:
      "https://storecdn.goqii.com/emailer/41278_1610103579.jpeg",
    route: "tel:+918419940404", // This will trigger a call on phones
  },
];

const Fsn170Support = () => {
  const navigate = useNavigate();

  const handleNavigate = (url) => {
    if (url.startsWith("tel:")) {
      // If it's a phone number, it will initiate a call
      window.location.href = url;
    } else {
      // Navigate to the given URL (For links like YouTube or Zendesk)
      window.open(url, "_blank");
    }
  };

  return (
    <div className="support-container">
     <div className="support-titlebar">
    <div className="support-back-button" onClick={() => navigate(-1)}>
      <ArrowForwardIos style={{ transform: "rotate(180deg)" }} />
    </div>
    <div className="support-title">Support</div>
    <div></div> {/* Empty div to keep title centered */}
  </div>
      <ul className="support-list">
        {supportItems.map((item) => (
          <li
            key={item.text}
            className="support-list-item"
            onClick={() => handleNavigate(item.route)}
          >
            <div className="support-list-icon">
              <img src={item.iconUrl} alt={item.text} />
            </div>
            <div className="support-list-text">{item.text}</div>
            <ArrowForwardIos className="support-arrow" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Fsn170Support;